<template>
  <div>
    <PageHeader page-name="Категории">
      <template>
        <router-link :to="{ name: 'CreateCategoryAttribute' }">
          <el-button type="primary">
            Создать Атрибут
          </el-button>
        </router-link>
      </template>
    </PageHeader>

    <MainPanel>
      <el-table
        :data="categoriesAttributes"
        style="width: 100%"
      >
        <el-table-column
          label="Назва"
          prop="title"
        />
        <el-table-column
          label="Название"
          prop="title_ru"
        />
        <el-table-column
          label="Позиция"
          prop="position"
        />
        <el-table-column
          label="Slug"
          prop="slug"
        />
        <el-table-column
          label="Категория"
          prop="category.name"
        />
        <el-table-column
          label="Действия"
        >
          <template #default="{ row }">
            <div class="category-column__item category-column__item--action">
              <el-button
                icon="el-icon-edit"
                size="small"
                type="success"
                @click="onEdit(row.id)"
              />

              <el-button
                icon="el-icon-delete"
                size="small"
                type="danger"
                @click="onDelete(row.id)"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>
    </MainPanel>
  </div>
</template>

<script>
import MainPanel from '@/components/common/MainPanel'
import { mapActions } from 'vuex'
import PageHeader from '@/components/common/PageHeader.vue'

export default {
  name: 'CategoryAttributesPage',
  components: { PageHeader, MainPanel },
  data() {
    return {
      categories: [],
      categoriesAttributes: [],
      availableCategories: [],
    }
  },
  async mounted () {
    this.categories = await this.fetchCategories()
    this.categoriesAttributes = await this.fetchCategoriesAttributes();
    this.availableCategories = this.categories.flatMap(category => category.children || []);
  },
  methods: {
    ...mapActions('wishes/categories', ['deleteAttribute', 'fetchCategories']),
    ...mapActions('wishes/categories', ['fetchCategoriesAttributes']),
    async onEdit (id) {
      if (!id) {
        console.error('ID is undefined')
        return
      }
      await this.$router.push({ name: 'UpdateCategoryAttribute', params: { id } })
    },
    async onDelete (id) {
      try {
        const res = await this.$confirm('Вы уверены, что хотите удалить атрибут категории?')
        if (res) {
          await this.deleteAttribute(id)
          window.location.reload()
        }
      } catch (error) {
        console.error(error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/_variables.sass';

.category-node {
  padding: 4px 0;
  display: flex;
  justify-content: space-between;
  flex: 1;
  align-items: center;

  &.category-node--has-not-children {
    cursor: default;
  }
}

::v-deep .el-tree-node__content {
  height: 46px;
}

.category-node-right {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 10px;
}

::v-deep .el-tree-node {
  padding: 0;
}

::v-deep .el-tree-node:not(:last-child) {
  margin: 0;
}

.el-tree {
  display: flex;
  flex-direction: column;
}

::v-deep .el-tree-node__expand-icon {
  font-size: 22px;
  color: $color-text-accent-customer;
}

.categories-tree__item {
  display: flex;
  align-items: center;
  padding: 8px 0;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    color: #409EFF;
  }

  &.is-active {
    color: #409EFF;
    font-weight: bold;
  }

  .el-icon-folder {
    margin-right: 8px;
    font-size: 16px;
  }

  .el-icon-document {
    margin-right: 8px;
    font-size: 16px;
  }

  .el-icon-arrow-right {
    margin-left: auto;
    font-size: 12px;
    transition: transform 0.3s ease;
  }

  &.is-expanded {
    .el-icon-arrow-right {
      transform: rotate(90deg);
    }
  }
}

.el-button + .el-button {
  margin-left: 0;
}

.el-button .fa {
  margin-right: 0;
}

.category-node__name-wrapper {
  display: flex;
  align-items: center;
  gap: 15px;
}

.category-node__active-badge {
  height: 12px;
  width: 12px;
  min-width: 12px;
  border-radius: 50%;
  background: #f62e40;

  &.category-node__active-badge--active {
    background: #67C23A;
  }
}

.category-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  align-items: center;
  gap: 10px;
}

.category-column__item {
  font-weight: bold;
  font-size: 13px;
  text-align: center;

  &.category-column__item--action {
    width: 170px;
    display: flex;
    justify-content: flex-start;
    gap: 10px
  }

  &.category-column__item--active {
    width: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &.category-column__item--position {
    width: 90px;
  }

  &.category-column__item--position-list {
    width: 90px;
  }
}
</style>
